import React from "react";

import type { SxProps } from "@mui/material";

import { Container } from "./styles";
import UpsellModuleActions, {
  UpsellModuleActionsProps,
} from "./UpsellModuleActions";
import UpsellModuleInnerContent, {
  UpsellModuleInnerContentProps,
} from "./UpsellModuleInnerContent";

export interface UpsellModuleProps {
  children: UpsellModuleInnerContentProps["children"];
  /* Base color for the background circles */
  color?: React.CSSProperties["color"];
  img?: UpsellModuleInnerContentProps["img"];
  cta?: UpsellModuleActionsProps["cta"];
  onDismiss?: UpsellModuleActionsProps["onDismiss"];
  sx?: SxProps;
}

const UpsellModule = ({
  cta,
  img,
  children,
  color,
  onDismiss,
  sx,
}: UpsellModuleProps) => (
  <Container sx={sx} color={color}>
    <UpsellModuleInnerContent img={img}>{children}</UpsellModuleInnerContent>
    <UpsellModuleActions cta={cta} onDismiss={onDismiss} />
  </Container>
);

export default UpsellModule;
